export enum ChartOfAccountTypesEnum {
  Unknown = 0,
  Assets = 100,
  Liabilities = 200,
  Equity = 300,
  Revenue = 400,
  Expenses = 500
}
